import { debounceTime } from 'rxjs';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuthFacade } from '@ellf/app-auth';
import { NgrxLoaderFacade } from '@ellf/app-ngrx-loader';

@Component({
  selector: 'ellf-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppComponent {
  title = 'Software Ingegneria Clinica Brescia';
  isLoaderVisible$ = this.loaderFacade.isLoaderVisible$.pipe(debounceTime(250));
  loaderText$ = this.loaderFacade.loaderText$;
  constructor(
    public authFacade: AuthFacade,
    private loaderFacade: NgrxLoaderFacade,
  ) {}

  //   const token = this.oidcSecurityService.getAccessToken();
  //   import { HttpHeaders } from '@angular/common/http';

  // const token = this.oidcSecurityServices.getAccessToken();

  // const httpOptions = {
  //   headers: new HttpHeaders({
  //     Authorization: 'Bearer ' + token,
  //   }),
  // };
}
